import { PageBlocksVoter } from './blocks';

export class PageBlocksPublishVoter extends PageBlocksVoter {
    supports(request) {
        return request.resource === 'page-blocks-publish';
    }
}
